/**
     * @desc 查询用户的交易历史信息列表
用于用户页HISTORY
     */

import * as defs from '../../baseClass';
import { PontCore } from '../../pontCore';
import * as ajax from '../../../utils/request';

export class Params {}

export const init = new defs.Result();

export function request(params, body, options = {}) {
  return ajax.post('/trading/getUserTradingHistory', params);
}

export function upload(params, body, options = {}) {
  return ajax.upload('/trading/getUserTradingHistory', params);
}
